import React from 'react';
import styles from '../css/hipaaBanner.module.scss';

const HipaaBanner = React.memo((): JSX.Element => {
  return (
    <div className={styles.hipaaBanner}>
      <p>
        Pivot is compliant with the Health Insurance Portability and
        Accountability Act of 1996 (HIPAA) and FDA regulations. We at Pivot take
        your privacy and security very seriously and we will never sell your
        data.
      </p>
    </div>
  );
});

export default HipaaBanner;
